import { STATUS } from "@/constants/statuses";
import ReviewEntity from "@apps/reviews/entities/ReviewEntity";
import { Store, StoreConfig } from "@datorama/akita";
import { injectable } from "tsyringe";

export type LeaveReviewState = {
    status: STATUS;
    leaveReviewStatus: STATUS;
    leaveReviewError: Error | null;
    review: ReviewEntity | null;
    leaveReviewCount: number;
};

function createInitialState(): LeaveReviewState {
    return {
        status: STATUS.VIRGIN,
        leaveReviewStatus: STATUS.VIRGIN,
        leaveReviewError: null,
        review: null,
        leaveReviewCount: 0,
    };
}

@injectable()
@StoreConfig({ name: "LeaveReviewStore" })
class LeaveReviewStore extends Store<LeaveReviewState> {
    constructor() {
        super(createInitialState());
    }
}

export default LeaveReviewStore;
